import React from "react";
import { useStateContext } from "../contexts/ContextProvider";
import Chatbox from "./Chatbox";

import { FaChevronLeft } from "react-icons/fa";

const MessagesModal = (props) => {
  const { senderId, recipientId } = props;
  const {
    user,
    handleModal,
    conversations,
    conversationId,
    messageRecipientId,
  } = useStateContext();

  const currentConversation = conversations.find(
    (x) => x.id === conversationId
  );

  console.log(
    "sender:",
    senderId,
    "recipient:",
    recipientId,
    "other recipient:",
    messageRecipientId
  );

  return (
    <div
      className="w-screen fixed left-0 right-0 top-20 bg-slate-200 border-gray-300 z-30 
      overscroll-none"
    >
      <div
        className="flex items-center h-10 bg-snappily-orange border-gray-300 
        border-t-1 text-xl text-white p-3 gap-x-3 cursor-pointer z-20"
        onClick={() => handleModal("messages")}
      >
        <FaChevronLeft />
        Close message
      </div>
      <div className="w-full h-screen overflow-y-scroll">
        <Chatbox
          senderId={senderId ? senderId : user.id}
          recipientId={recipientId ? recipientId : messageRecipientId}
        />
      </div>

      {/* <div className="flex justify-center w-full mt-5 mb-20">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("messages")}
        />
      </div> */}
    </div>
  );
};

export default MessagesModal;
